var CustomThemeFunction = (function ($) {

    function init() {
        var $about_shop = $('#about-shop');
        
        function calculateDefaultHeight() {
            var height = 0;
            var shopDescriptionHeaderBlock = $(".about-shop-description__text h2");
            if (shopDescriptionHeaderBlock.length) {
                if($(window).width() < 767){
                    if($('.about-shop-description__text p:nth-of-type(3)')[0]){
                        return $('.about-shop-description__text p:nth-of-type(3)')[0].offsetTop; //mobile - height with 2 paragraphs
                    }
                } else {
                    return shopDescriptionHeaderBlock[0].offsetTop + shopDescriptionHeaderBlock[0].offsetHeight; // desktop - height with header
                }
            }
            
            return height;
		}
        
        //Show/hide text on home page
        if ($about_shop.length) {
            var $defaultHeight = null;
			var $selector = $('.about-shop-description');
	
			// default value of height (px)
			$defaultHeight = calculateDefaultHeight();
			
			if ($(window).width() < 767){
				$selector.animate({height: $defaultHeight}, 600);
            }
            
			
			$about_shop.on('click', function () {
				$(this).toggleClass('active');
				
				if ($(this).hasClass('active') && $(window).width() < 767) {
					$selector.animate({height: '100%'}, 600);
                } else if ($(this).hasClass('active') && $(window).width() > 767) {
					$selector.animate({height: $defaultHeight}, 600);
                } else if ($(window).width() < 767) {
					$selector.animate({height: $defaultHeight}, 600);
                } else
					$selector.animate({height: '100%'}, 600);
			});
        }

        // Regional search link list
        if ($("#regional-search .picturebox").length) {
            $("#regional-search .picturebox").on("click", function () {

                var dataId = $(this).attr("data-id");
                var $elem = $("#" + dataId);
                if ($elem.attr('style') == 'display: block;') {
                    $elem.slideUp(200);
                } else {
                    $(".linklist").each(function () {
                        $(this).slideUp(200);
                    });
                    $elem.slideToggle(200);
                }
            });
        }

        if ($("#faq").length) {
            if ($(window).width() < 979) {
                $('#faq .content div.post .post').appendTo('#faq .content div.pre');
            } else {
                $('#faq .content div.pre .post').appendTo('#faq .content div.post');
            }
            $(window).on('resize', function () {
                if ($(window).width() < 979) {
                    $('#faq .content div.post .post').appendTo('#faq .content div.pre');
                } else {
                    $('#faq .content div.pre .post').appendTo('#faq .content div.post');
                }
            });
        }

        var topNavigationList = $('.top-navigation-list__item a');
        if (topNavigationList.length) {
			var locationPath = window.location.pathname;
            var arrayOfLinks = topNavigationList;
			for (var i = 0; i < arrayOfLinks.length; i++){
                var link = $(arrayOfLinks[i]);
				if (locationPath === link.attr('href')){
                    link.addClass('selected-link');
                    link.closest('.top-navigation-list__item').addClass('current-locate');
                    break;
                }
			}
            topNavigationList.on("click", function () {
                if ($(window).width() > 767) {
                    elementMenuResize(this);
                }
            });
		}
    }

    function initNavigation (){
        //Show/hide navigation on mobiles
        $('#burger-nav').on('click', function () {
            $('#burger-nav').toggleClass("open");
            $('.top-navigation').toggleClass("open");
        });

        if (IsMobile.any() || $(window).width() < 767) {
            // If a link has a dropdown, add sub menu toggle.
            $('nav ul li a.has-sublist').on('click', function (e) {

                e.preventDefault();

                if ($(window).width() < 767) {
                    $('.has-sublist').not($(this)).removeClass('active');
                    $(this).siblings('.top-navigation-sublist-container').toggle();
                    // Close one dropdown when selecting another
                    $('.top-navigation-sublist-container').not($(this).siblings()).hide();
                } else {
                    $(this).siblings().css({'display': ''});
                }

            });
        }
    }

    function customerSupportAdvantageInit(){
        var customerServiceLink = $(".main-footer-shop-advantages-container .CUSTOMER_SUPPORT");
        if (!customerServiceLink.length){
            return;
        }
        customerServiceLink.on('click', function (e) {
            if (IsMobile.any()) {
                $(".header-container .hot-line-link-wrapper.customer-support-mobile").trigger(e)
            } else {
                $(".header-container .hot-line-link-wrapper.customer-support-desktop").trigger(e)
            }
        });
    }

    function languageChangeEvent(langSel) {
        if (!langSel.length){
            return;
        }

        $(langSel).on("change", function () {
            var url = window.location.pathname;
            var splitUrl = window.location.href.split("?");
            var queryParams = (splitUrl.length === 2) ? splitUrl[1] : null;
            var query = (queryParams) ? encodeURIComponent(queryParams) : "";
            var changeLanguageUrl = ACC.config.contextPath
                + "/_lang/set?language=" + $(this).val()
                + "&url=" + url
                + "&query=" + query;

            $.ajax({
                url: changeLanguageUrl
            }).done(function (data) {
                window.location = data + window.location.hash;
                if (window.location.hash) {
                    location.reload();
                }
            });
        });
    }

    function allMenuResize() {
        [].forEach.call($('.top-navigation-list__item a'), function (el) {
            elementMenuResize(el);
        });
    }

    function elementMenuResize(rootElement) {
        var subList = rootElement.parentNode.getElementsByClassName('top-navigation-sublist-container');
        if (subList.length) {
            var element = subList[0];
            var elementWidth = element.clientWidth;
            if (elementWidth > 0) {
                var positionLeft = rootElement.getBoundingClientRect().left;
                var styleLeft = $(window).width() - elementWidth - positionLeft;
                if (positionLeft + elementWidth > $(window).width()) {
                    element.style.left = ((positionLeft + styleLeft < 0) ? "-" + positionLeft : styleLeft) + "px";
                }
            }
        }
    }

    return {
        init: init,
        initNavigation: initNavigation,
        customerSupportAdvantageInit: customerSupportAdvantageInit,
        languageChangeEvent: languageChangeEvent,
        allMenuResize: allMenuResize
    }
})(jQuery);

$(document).mouseup(function(e){
    var container = $("#chat-options-menu");
    if(!container.is(e.target) && container.has(e.target).length === 0){
        container.hide();
    }
});

$(document).ready(function () {
    CustomThemeFunction.init();
    CustomThemeFunction.initNavigation();
    CustomThemeFunction.customerSupportAdvantageInit();
    CustomThemeFunction.languageChangeEvent('.j-language-selector');

    if (IsMobile.any()) {
        $(window).on('resize', function () {
            if ($(window).width() > 767) {
                CustomThemeFunction.allMenuResize();
            }
        });
    }
});